import { render, staticRenderFns } from "./OMultiCheckbox.vue?vue&type=template&id=fbc9d47a&scoped=true&"
import script from "./OMultiCheckbox.vue?vue&type=script&lang=js&"
export * from "./OMultiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./OMultiCheckbox.vue?vue&type=style&index=0&id=fbc9d47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc9d47a",
  null
  
)

export default component.exports